export default class MakeMeDateElement extends HTMLElement {

    connectedCallback() {
        new AirDatepicker(this.querySelector('input'), {
            locale: window.TEXTS.CalendarLocale,
            toggleSelected: false,
            minView: 'days',
            dateFormat: 'dd/MM/yyyy',
            autoClose: true,
        });
    }

}
window.customElements.define('make-me-date', MakeMeDateElement);

